import { render } from "./AddressEdit.vue?vue&type=template&id=5000c184"
import script from "./AddressEdit.vue?vue&type=script&lang=js"
export * from "./AddressEdit.vue?vue&type=script&lang=js"

import "./AddressEdit.vue?vue&type=style&index=0&id=5000c184&lang=less"
script.render = render

export default script